enum NotificationType
{
    SUCCESS = 0,
    WARNING = 1,
    ERROR = 2,
    INFO = 3,
    CLEAR = 4
}

export { NotificationType };